import template from './payment-codes-container.html';

const DIRECTIVE_NAME = PaymentCodesContainer.DIRECTIVE_NAME = 'ktPaymentCodesContainer';
export default function PaymentCodesContainer() {
    return {
        restrict: 'A',
        template,
        bindToController: true,
        controller: PaymentCodesContainerController,
        controllerAs: '$ctrl',
        scope: {
            model: `=${DIRECTIVE_NAME}`,
            tripDetails: `=${DIRECTIVE_NAME}TripDetails`,
        },
        link: ($scope, $elem, $attrs, $ctrl) => $ctrl.$onInit(),
    };
}

export function PaymentCodesContainerController(
    paymentCodesContainerService,
    travellerUtils
) {
    'ngInject';
    const vm = this;
    Object.assign(vm, {
        $onInit,
        isPerTravellerCheckboxChecked: false,
        onPerTravellerCheckboxChange,
        getFullName: travellerUtils.getTravellerFullName,
    });

    function $onInit() {
        setErrorMessageForPaymentCodes();
        reinitializePaymentCodesModel();
        vm.isPerTravellerCheckboxVisible = paymentCodesContainerService.isPerTravellerCheckboxVisible(vm.tripDetails);
        vm.paymentCodes = paymentCodesContainerService.processPaymentCodes(vm.tripDetails.PaymentCodes);
    }
    function setErrorMessageForPaymentCodes() {
        vm.errorMessageForPaymentCode = vm.tripDetails.HasExtendedPaymentCodes
            ? 'Incorrect value for Activity code'
            : 'Incorrect value for Payment code';
    }

    function onPerTravellerCheckboxChange() {
        reinitializePaymentCodesModel();
    }

    function reinitializePaymentCodesModel() {
        vm.model = paymentCodesContainerService.reinitializeModel(
            vm.isPerTravellerCheckboxChecked,
            vm.tripDetails,
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/payment-codes/payment-codes-container/payment-codes-container-component.js